import { Component, OnInit } from '@angular/core';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';

@Component({
  selector: 'app-tour-dialog',
  templateUrl: './tour-dialog.component.html',
  styleUrls: ['./tour-dialog.component.css']
})
export class TourDialogComponent implements OnInit {

  constructor(private sideNav : SideNavServiceService) { }

  ngOnInit(): void {
  }

  triggerTour(){
    this.sideNav.tourInitiator()
  }

}
